import { render, staticRenderFns } from "./cashForm.vue?vue&type=template&id=0ff656e2"
import script from "./cashForm.vue?vue&type=script&lang=js"
export * from "./cashForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports